import * as yup from 'yup'

export const loginSchema = yup.object({
  login_id: yup.string().trim().required('ログインIDを入力してください。'),
  password: yup.string().trim().required('パスワードを入力してください。')
})

export const loginFreeSchema = yup.object({
  sub_domain: yup.string().trim().required('サイトIDを入力してください。'),
  login_id: yup.string().trim().required('ログインIDを入力してください。'),
  password: yup.string().trim().required('パスワードを入力してください。')
})
